export const RACE_CARD_SWIPE_THRESH_HOLD = 100;

export const RACE_CARDS_COLLAPSED_TIME_FORMS = 'RACE_CARDS_COLLAPSED_TIME_FORMS';
